// Constants

// navbar links
export const NAVBAR_LINKS = [
    {to: '/', text: 'Home'},
    {to: '/about', text: 'About'},
    {to: '/resume', text: 'Resume'},
    {to: '/projects', text: 'Projects'},
    {to: '/contact', text: 'Contact'},
];

// Urls
export const HOME_PAGE_URL = '/home';
export const ABOUT_PAGE_URL = '/about';